import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { sanitizeUploadFilename } from "../utils/sanitizeUploadFilename";

// Configuración de AWS
const REGION = "us-east-1"; // Asegúrate de usar la región correcta
const BUCKET_NAME = "ventaflow-bucket"; // Nombre de tu bucket
const S3_BUCKET_URL = `https://${BUCKET_NAME}.s3.${REGION}.amazonaws.com`;

const s3Client = new S3Client({
  region: REGION,
  credentials: {
    accessKeyId: import.meta.env.VITE_AWS_ACCESS_KEY_ID || '',
    secretAccessKey: import.meta.env.VITE_AWS_SECRET_ACCESS_KEY || '',
  },
});

export const s3Service = {
  async uploadImage(file: File): Promise<string> {
    // Sanitizar y acotar el nombre del archivo (las URLs se persisten en varchar(255))
    const sanitizedFileName = `${Date.now()}-${sanitizeUploadFilename(file.name)}`;

    const uploadParams = {
      Bucket: BUCKET_NAME,
      Key: `ventaflow-orders-products/${sanitizedFileName}`, // Nombre del archivo procesado
      Body: file,
      ContentType: file.type,
    };

    try {
      // Subir el archivo al bucket S3
      const command = new PutObjectCommand(uploadParams);
      await s3Client.send(command);

      // Generar una URL pública (o presignada si es necesario)
      const fileUrl = `${S3_BUCKET_URL}/${uploadParams.Key}`;
      return fileUrl;
    } catch (error) {
      console.error("Error uploading image to S3:", error);
      throw new Error("Failed to upload image.");
    }
  },
};
